import {
  FETCH_TASKS_MANAGER_FILTERS_INIT,
  FETCH_TASKS_MANAGER_FILTERS_SUCCESS,
  FETCH_TASKS_MANAGER_FILTERS_FAILURE,
  SET_FILTER_TASKS_MANAGER
} from './types';
import API from './api';

/* Actions Creators */

export function setFilterTasksManager(obj) {
  return {
    type: SET_FILTER_TASKS_MANAGER,
    payload: obj
  };
}

export function fetchFiltersSuccess(data) {
  return {
    type: FETCH_TASKS_MANAGER_FILTERS_SUCCESS,
    payload: data
  };
}

export function fetchFiltersFailure(error) {
  return {
    type: FETCH_TASKS_MANAGER_FILTERS_FAILURE,
    payload: error
  };
}

export function fetchFiltersInit() {
  return {
    type: FETCH_TASKS_MANAGER_FILTERS_INIT
  };
}

export function fetchTasksManagerFilters() {
  return async dispatch => {
    dispatch(fetchFiltersInit());
    try {
      let data = await API.data.getFilters();
      dispatch(fetchFiltersSuccess(data));
    } catch (error) {
      dispatch(fetchFiltersFailure(error));
    }
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/tasks_manager/index.js